import { ProductSynopses } from "CommonData/poco";

const containerEl: Element = document.getElementsByClassName('js-description-container')[0];
const nameEl: Element = document.getElementsByClassName('js-description-product-name')[0];
// const priceEl: Element = document.getElementsByClassName('js-description-price')[0];
const imageEl: HTMLImageElement = document.getElementsByClassName('js-description-image')[0] as HTMLImageElement;
const descriptionEl: Element = document.getElementsByClassName('js-product-description')[0];
const websiteLinkEl: Element = document.getElementsByClassName('js-description-website-link')[0];
const closeEl: Element = document.getElementsByClassName('js-description-close')[0];

closeEl.addEventListener('click', () => {
    ProductDescription.hide();
});

export class ProductDescription {
    public static async show(productSynopses?: ProductSynopses): Promise<void> {
        try {
            if (productSynopses) {
                await this.renderProductDescription(productSynopses);
            }
        } finally {
            containerEl.classList.remove('hidden');
        }
    }

    public static hide(): void {
        containerEl.classList.add('hidden');
    }

    private static async renderProductDescription(productSynopses: ProductSynopses): Promise<void> {
        await this.loadImage(productSynopses.heroImageUrl);
        nameEl.innerHTML = productSynopses.name;
        descriptionEl.innerHTML = productSynopses.description;
        websiteLinkEl.setAttribute('href', productSynopses.websiteUrl);

    }

    private static loadImage(imageUrl: string): Promise<HTMLImageElement> {
        return new Promise((resolve, reject) => {
            imageEl.onload = () => resolve(imageEl);
            imageEl.onerror = reject;
            imageEl.src = imageUrl ? imageUrl.replace('t_mrheroimage', 't_mrheroimage,w_1000,ar_16:9') : '';
        });
    }
}